export const JOBS = [
  {
    id: "freelance-react",
    title: "React Developer",
    type: "Freelance / Project-based",
    stack: ["React", "Vite", "Tailwind CSS"],
    description: "Landing pages, dashboards, client portals — anything UI. I get the brief, you build it. Clean components, good naming, no spaghetti.",
    earn: "80% of project value",
    available: true,
    brief: {
      what: "Build React frontends for real client projects — landing pages, dashboards, portals, booking UIs. You'll get a clear brief with design references or a rough layout. No guesswork.",
      who: "Someone who can work independently and is okay with uncertainty — there's no fixed schedule here. You'll hear from us when something fits. If you need consistent income, this isn't it. But if you want real client work on the side, it's a good fit.",
      how: [
        "We reach out when a React project comes in — no set timeline on when that happens",
        "You get the brief and confirm if you're available and interested",
        "You build and hand off clean, working code",
        "We handle the client, feedback, and deployment",
        "Your 80% is paid once the client approves — our 20% covers domains, hosting, infra",
      ],
      range: "₹4,000 – ₹24,000 per project",
      timeline: "Usually 3–10 days per project",
    },
  },
  {
    id: "freelance-node",
    title: "Node.js / Backend Developer",
    type: "Freelance / Project-based",
    stack: ["Node.js", "Express", "REST APIs", "MySQL"],
    description: "APIs, auth flows, admin panels, webhooks. I handle client comms and scoping. You handle the server logic and ship clean endpoints.",
    earn: "80% of project value",
    available: true,
    brief: {
      what: "Build Node.js/Express backends for client projects — REST APIs, auth systems, admin data flows, webhook handlers, DB integrations. You'll get a clear spec of what endpoints and logic are needed.",
      who: "Someone comfortable with Express and MySQL who's okay with irregular work. This isn't a consistent gig — we ping you when something comes in. Could be soon, could be a while. If that's fine with you, let's talk.",
      how: [
        "We scope the backend with the client and reach out when it's ready to build",
        "You get a written spec — routes, DB schema, auth flow — no guessing",
        "You build and test, we review and deploy on our infra",
        "Client never contacts you — we handle all of that",
        "80% paid on delivery. Our 20% goes to server costs, domains, deployment tools",
      ],
      range: "₹5,000 – ₹30,000 per project",
      timeline: "Usually 5–14 days per project",
    },
  },
  {
    id: "fullstack",
    title: "Full-Stack Developer",
    type: "Freelance / Project-based",
    stack: ["React", "Node.js", "MySQL", "Cloudflare"],
    description: "End-to-end project ownership. Design to deployment. Ideal if you're comfortable handling both sides independently without too much back-and-forth.",
    earn: "80% of project value",
    available: true,
    brief: {
      what: "Own the full project — React frontend, Node.js backend, DB, the works. These are typically mid-size projects for schools, clinics, or small businesses. I handle client comms, you handle the build.",
      who: "Someone who can own a project end-to-end without needing to be managed. Work comes in irregularly — we reach out, you decide if you're in. No pressure either way, but once you commit, you deliver.",
      how: [
        "We take on the project and reach out when it's ready — timing varies",
        "You get the full brief: features, screens, data model, stack",
        "You build independently, async check-ins if needed",
        "We review, handle client feedback, and deploy — you're not on calls",
        "80% of the agreed fee paid on approval. The 20% covers our infra, domains, and deployment costs",
      ],
      range: "₹10,000 – ₹40,000+ per project",
      timeline: "Usually 2–4 weeks per project",
    },
  },
];